import React from 'react';
import { Form } from 'react-final-form';
import classnames from 'classnames';

import { SkillTaxonomyDto } from '@eva/types/dto/skills';
import type { SkillTaxonomySection, SkillTaxonomyTreeDto } from '@eva/types/dto';
import { ViewOnlyNote } from 'shared/ui/Note/ViewOnlyNote';
import PageSpinner from 'shared/ui/Spinner/PageSpinner';

import { SkillTaxonomyTreeItemForm } from 'entities/skillTaxonomy/SkillTaxonomyTreeItemForm';
import { useSkillTaxonomyTree } from 'entities/skillTaxonomy/hooks/useSkillTaxonomyTree';

import type { UseQueryResult } from 'react-query/types/react/types';

import { onExpandGroup } from '../../functions';
import { SkillTaxonomyTreeButtons } from '../../ui';

type SkillTaxonomyTreeItemType = {
  note: string;
  skills: SkillTaxonomySection['skills'];
  highlightSkillLabelMemoized?: (skill: any) => void;
  useFetchSkillTaxonomyTree: () => UseQueryResult<SkillTaxonomyTreeDto>;
  name: SkillTaxonomyDto['name'];
  skillProficiencies: SkillTaxonomyDto['proficiencies'];
  defaultExpandedSkills?: number[];
};

export const SkillTaxonomyTreeItem: React.FC<SkillTaxonomyTreeItemType> = ({
  skills,
  note,
  highlightSkillLabelMemoized,
  useFetchSkillTaxonomyTree,
  skillProficiencies,
  name,
  defaultExpandedSkills,
}) => {
  const { error, isLoading, onExpandTree, skillTaxonomyTree, setSkillTaxonomyTree } = useSkillTaxonomyTree({
    useFetchSkillTaxonomyTree,
    defaultExpandedSkills,
  });

  const renderTopButtons = (
    <div className="pull-right">
      <SkillTaxonomyTreeButtons onExpandTree={onExpandTree} />
    </div>
  );

  if (isLoading) {
    return <PageSpinner />;
  }

  if (error) {
    return <h3 className="text-danger">{error}</h3>;
  }

  const formClassName = classnames(['section']);

  return (
    <div>
      <div className="taxonomy-wrapper">
        <Form
          onSubmit={() => {}}
          initialValues={{
            skills,
          }}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit} className={formClassName}>
              {renderTopButtons}
              <h3 className="text-primary">{name}</h3>
              <ViewOnlyNote note={note} />
              {skillTaxonomyTree && (
                <SkillTaxonomyTreeItemForm
                  isDisabled={true}
                  isUpdatingEntity={false}
                  isEditSkill={false}
                  skillTaxonomyTree={skillTaxonomyTree}
                  skillProficiencies={skillProficiencies}
                  highlightSkillLabelMemoized={highlightSkillLabelMemoized}
                  onExpandGroup={onExpandGroup({
                    skillTaxonomyTree,
                    setSkillTaxonomyTree,
                  })}
                />
              )}
            </form>
          )}
        />
      </div>
    </div>
  );
};
